import React, { useEffect, useState } from "react";
import { Spinner, ProgressBar } from "react-bootstrap";

const LoadingScreen = () => {
  const [progress, setProgress] = useState(0);

  // Simulate progress bar fill
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        const newProgress = oldProgress + 20;
        return newProgress >= 100 ? 100 : newProgress;
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-container">
      <Spinner animation="border" role="status" className="loading-spinner" />
      <h2 className="loading-text fade-in">Generating your AI-powered itinerary...</h2>
    

      <p className="loading-subtext">Powered by <span className="ai-highlight">Concord AI 🤖</span></p>
    </div>
  );
};

export default LoadingScreen;
